"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _BusinessSchoolPopup = _interopRequireDefault(require("./components/BusinessSchoolPopup.vue"));
var _BusinessSchool = require("@/api/operationManagement/BusinessSchool");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    BusinessSchoolPopup: _BusinessSchoolPopup.default
  },
  data: function data() {
    return {
      pagination: {
        total: 0 // 条数
      },
      nameList: [{
        name: '新人指导',
        id: 1
      }, {
        name: '进阶课程',
        id: 2
      }, {
        name: '大咖分享',
        id: 3
      }, {
        name: '常见问题',
        id: 4
      }],
      selectNameList: 1,
      queryData: {
        title: '',
        classify: '',
        enable: 1,
        page: {
          page: 1,
          size: 10
        }
      },
      dataList: []
    };
  },
  created: function created() {
    this.listBusinessCollege();
  },
  methods: {
    onChangeName: function onChangeName(id) {
      this.selectNameList = id;
      this.queryData.classify = id;
      this.listBusinessCollege();
    },
    onAdd: function onAdd() {
      this.$refs.businessSchoolPopup.open({
        type: 'add',
        name: '添加新人指导',
        classify: this.selectNameList
      });
    },
    onEditor: function onEditor(val) {
      this.$refs.businessSchoolPopup.open({
        id: val.id,
        name: '添加新人指导',
        type: 'editor',
        classify: this.selectNameList
      });
    },
    onDelete: function onDelete(val) {
      var _this = this;
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deleteBusinessCollege(Number(val.id));
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.listBusinessCollege();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.listBusinessCollege();
    },
    onRefresh: function onRefresh() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.listBusinessCollege();
    },
    listBusinessCollege: function () {
      var _listBusinessCollege2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _BusinessSchool.listBusinessCollege)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.dataList = res.data.data;
                this.pagination.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listBusinessCollege() {
        return _listBusinessCollege2.apply(this, arguments);
      }
      return listBusinessCollege;
    }(),
    deleteBusinessCollege: function () {
      var _deleteBusinessCollege2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(id) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                id: id
              };
              _context2.n = 1;
              return (0, _BusinessSchool.deleteBusinessCollege)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
                this.listBusinessCollege();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function deleteBusinessCollege(_x) {
        return _deleteBusinessCollege2.apply(this, arguments);
      }
      return deleteBusinessCollege;
    }()
  }
};